import { ChangeDetectionStrategy,  Component } from "@angular/core";

@Component({
  selector: "member-rxcm",
  templateUrl: "./rxcm.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RxcmComponent {}
